import { success, error, abort } from 'redux-saga-requests';
import { GET_CAMERA_MODELS } from '../constants';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_CAMERA_MODELS: {
      return {
        ...state,
        [action.meta.name]: {
          response: state[action.meta.name] ? state[action.meta.name].response : undefined,
          resolved: false,
          failed: false,
          error: null,
        },
      };
    }
    case success(GET_CAMERA_MODELS): {
      return {
        ...state,
        [action.meta.name]: {
          response: (action.payload.data.content.model_parameters || {}).model_id,
          resolved: true,
          failed: false,
          error: null,
        },
      };
    }
    case error(GET_CAMERA_MODELS): {
      if (action.payload.response.status >= 400 && action.payload.response.status < 600) {
        return {
          ...state,
          [action.meta.name]: {
            resolved: true,
            failed: true,
            error: action.payload.response.data.result.errorCode,
          },
        };
      }
      return {
        ...state,
        [action.meta.name]: {
          resolved: true,
          failed: true,
          error: action.payload.toString ? action.payload.toString() : '',
        },
      };
    }
    case abort(GET_CAMERA_MODELS):
      return {
        ...state,
      };
    default:
      return state;
  }
}
